export default __webpack_public_path__ + "images/Pothi-Voan-Offset-roof.webp";